export default function useMainFooterItems() {
  return [
    {
      text: "legalNotice",
      publicDocument: "legal_notice_certipers.pdf",
    },
  ];
}
